import {
	Catalog,
	CatalogAdapter,
	CatalogsGoods,
	CatalogsGoodsAdapter,
} from '@interfaces/FW/common/Catalogs';

export const getCatalogsGoodsAdapter = (data: CatalogsGoodsAdapter[]): CatalogsGoods[] => {
	return data
		.map((item) => {
			return {
				nomenclature: item.Ссылка,
				nomenclatureName: item.Наименование,
				nomenclatureFullName: item.НаименованиеПолное,
				code: item.КодТовара,
				unit: item.ЕдиницаИзмерения,
				nomenclatureColor: item.НоменклатураЦвет,
			};
		})
		.sort((a, b) => b.code - a.code);
};

export const getCatalogAdapter = (data: CatalogAdapter[]): Catalog[] => {
	return data.map((item) => {
		return {
			ref: item.Ссылка,
			name: item.Наименование,
			contry: item.Страна,
		};
	});
};
